import config from '@config/config';
import { ServerProjectInfo } from '@modules/auth/components/types/project';
import api from '@src/lib/api';
import { ResourceFetch } from '@src/meta/types/api';

const { GET } = api;

interface ProjectResource {
  info: ResourceFetch<ServerProjectInfo, { projectId: string }>;
}

const ProjectResource: ProjectResource = {
  info: GET(`${config.identityServiceBasePath}/projects/:projectId/info`),
};

export default ProjectResource;
